module.exports = __webpack_public_path__ + "media/img/decorations/decoration-offices-left-40d01703636cf34b6f61e0f08c67db8b.svg";